module.exports = __webpack_public_path__ + "static/media/goal-ticker-logo.ec9a4139.svg";